/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSubmissionMode } from './PalReauthSubmissionMode';
import {
    PalReauthSubmissionModeFromJSON,
    PalReauthSubmissionModeFromJSONTyped,
    PalReauthSubmissionModeToJSON,
    PalReauthSubmissionModeToJSONTyped,
} from './PalReauthSubmissionMode';

/**
 * Optional. An empty request keeps the cycle's stored submission mode.
 * @export
 * @interface SubmitPalReauthSubmissionRequest
 */
export interface SubmitPalReauthSubmissionRequest {
    /**
     * 
     */
    submission_mode?: PalReauthSubmissionMode;
}



/**
 * Check if a given object implements the SubmitPalReauthSubmissionRequest interface.
 */
export function instanceOfSubmitPalReauthSubmissionRequest(value: object): value is SubmitPalReauthSubmissionRequest {
    return true;
}

export function SubmitPalReauthSubmissionRequestFromJSON(json: any): SubmitPalReauthSubmissionRequest {
    return SubmitPalReauthSubmissionRequestFromJSONTyped(json, false);
}

export function SubmitPalReauthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitPalReauthSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'submission_mode': json['submission_mode'] == null ? undefined : PalReauthSubmissionModeFromJSON(json['submission_mode']),
    };
}

export function SubmitPalReauthSubmissionRequestToJSON(json: any): SubmitPalReauthSubmissionRequest {
    return SubmitPalReauthSubmissionRequestToJSONTyped(json, false);
}

export function SubmitPalReauthSubmissionRequestToJSONTyped(value?: SubmitPalReauthSubmissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submission_mode': PalReauthSubmissionModeToJSON(value['submission_mode']),
    };
}

